// extracted by mini-css-extract-plugin
export var button = "_br-4";
export var hasDarkBackground = "_br-7";
export var hasLightBackground = "_br-6";
export var iconWrapper = "_br-0";
export var large = "_br-2";
export var medium = "_br-1";
export var small = "_br-5";
export var xsmall = "_br-3";